
import ComposeEmail from '@/components/email/ComposeEmail';
import { Email } from '@/context/email/types';

interface EmailComposeOverlayProps {
  showCompose: boolean;
  onClose: () => void;
  draftId?: string;
  onSent?: () => void;
  initialEmail?: Email | null;
  isReply?: boolean;
  isReplyAll?: boolean;
  isForward?: boolean;
}

const EmailComposeOverlay = ({
  showCompose,
  onClose,
  draftId,
  onSent,
  initialEmail,
  isReply,
  isReplyAll,
  isForward
}: EmailComposeOverlayProps) => {
  if (!showCompose) return null;

  const handleClose = () => {
    // The auto-save logic is handled in the ComposeEmail component
    onClose();
  };

  const handleSent = () => {
    if (onSent) {
      onSent();
    } else {
      onClose();
    }
  };

  return (
    <ComposeEmail
      onClose={handleClose}
      onMinimize={handleClose}
      draftId={draftId}
      onSent={handleSent}
      initialEmail={initialEmail}
      isReply={isReply}
      isReplyAll={isReplyAll}
      isForward={isForward}
    />
  );
};

export default EmailComposeOverlay;
